import { render, staticRenderFns } from "./window-alerts.vue?vue&type=template&id=08eba541"
import script from "./window-alerts.vue?vue&type=script&lang=ts"
export * from "./window-alerts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08eba541')) {
      api.createRecord('08eba541', component.options)
    } else {
      api.reload('08eba541', component.options)
    }
    module.hot.accept("./window-alerts.vue?vue&type=template&id=08eba541", function () {
      api.rerender('08eba541', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/alert/window-alerts.vue"
export default component.exports